export default "__VITE_ASSET__BrC8WBNh__"